import { Params, IdentifiersApproveInfo } from 'app/common/types/identifiers/approve'

import type { Request } from '../../../index'

type ParamsApi = {
  student_id: number
  number: string
}

export const convertParams = ({ studentId, identifierValue }: Params): [ParamsApi, null] => {
  return [
    {
      student_id: parseInt(studentId, 10),
      number: identifierValue.replace(/\s/g, ''),
    },
    null,
  ]
}

type ResultApi = {
  result: 'success'
  balance: number
  price: number
}

export const convertResult = (apiData: ResultApi): IdentifiersApproveInfo => {
  const { balance, price } = apiData
  return { balance, price }
}

export const GET_IDENTIFIERS_CHECK: Request<Params, IdentifiersApproveInfo, void> = [
  'cabinet/identifiers/check',
  'get',
  ['data'],
]
